import axios from 'axios';

export function init () {
    const videoReferences = document.querySelectorAll('.js-bg-video[data-videoid]');

    [...videoReferences].forEach((video) => {
        let videoId = video.dataset.videoid;

        if (!isNaN(parseFloat(videoId)) && isFinite(videoId)) {
            axios({
                method: 'get',
                url: '/video/get-data', 
                params: {
                    videoId: videoId
                },
                headers: { "X-Requested-With": "XMLHttpRequest" }
            })
            .then(response => {
                if (response.data) {
                    const videoFileData = response.data;

                    if (videoFileData.link) {
                        // Set the video src
                        video.src = videoFileData.link;

                        video.play();

                        video.addEventListener('canplay', (event) => {
                            // Show video
                            video.classList.add('opacity-100');
                        });
                    }
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
    });
}